import i18next from "i18next";
import { Moment } from "moment";

export type ApplyConditions = Record<ApplyConditionType, ApplyCondition[]>;

export interface ApplyCondition {
  type: ApplyConditionType;
  artistCode: string | null;
  shopKey: string | null;
  amount: number | null;
  purchaseStartAt: Moment | null;
  purchaseEndAt: Moment | null;
  membershipRegion: string | null;
}

export interface ApplyConditionDto {
  type: string;
  artistCode: string | null;
  shopKey: string | null;
  amount: number | null;
  purchaseStartAt: string | null;
  purchaseEndAt: string | null;
  region: string | null;
}

export enum ApplyConditionType {
  OFFICIAL_MEMBERSHIP = "OFFICIAL_MEMBERSHIP",
  WEVERSE_COMMUNITY = "WEVERSE_COMMUNITY",
  WEVERSE_ACCOUNT = "WEVERSE_ACCOUNT",
  DIGITAL_MEMBERSHIP = "DIGITAL_MEMBERSHIP",
  WEVERSE_SHOP = "WEVERSE_SHOP",
  PHONING = "PHONING",
}

export const ApplyConditionsToString = (conditionsByType: ApplyConditions) => {
  if (Object.keys(conditionsByType).length === 0) {
    return i18next.t("eventdetail_condition_none");
  }
  return Object.entries(conditionsByType)
    .map(([type, conditions]) => {
      switch (type) {
        case ApplyConditionType.OFFICIAL_MEMBERSHIP:
          return i18next.t("eventdetail_condition_membership", {
            membershiparea: conditions
              .map((condition) => condition.membershipRegion)
              .join(" / "),
          });
        case ApplyConditionType.WEVERSE_COMMUNITY:
          return i18next.t("eventdetail_condition_artist");
        case ApplyConditionType.WEVERSE_ACCOUNT:
          return i18next.t("eventdetail_condition_weaccount");
        case ApplyConditionType.DIGITAL_MEMBERSHIP:
          return i18next.t("eventdetail_condition_digital_membership");
        case ApplyConditionType.PHONING:
          return i18next.t("eventdetail_condition_phoning");
        case ApplyConditionType.WEVERSE_SHOP:
          return i18next.t("eventdetail_condition_merch");
        default:
          return "";
      }
    })
    .join(", ");
};
